import BusinessUnitSelect from 'ui-business-units-lib/components/BusinessUnitSelect';
import WithBusinessUnitsDataFetching from 'ui-business-units-lib/utils/WithBusinessUnitsDataFetching';
import { useCallback } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const BusinessUnitSelectorWithDataFetching = WithBusinessUnitsDataFetching(BusinessUnitSelect);
const StyledWrapper = styled.div.withConfig({
  displayName: "EmailCloneBusinessUnit__StyledWrapper",
  componentId: "ppl4yl-0"
})(["margin-top:16px;margin-bottom:13px;"]);
function EmailCloneBusinessUnit({
  canAccessBusinessUnit,
  onSelect,
  buId
}) {
  const handleChange = useCallback(value => {
    onSelect(value);
  }, [onSelect]);
  if (!canAccessBusinessUnit) {
    return null;
  }
  return /*#__PURE__*/_jsx(StyledWrapper, {
    children: /*#__PURE__*/_jsx(BusinessUnitSelectorWithDataFetching, {
      withHeader: true,
      onChange: handleChange,
      buId: buId
    })
  });
}
export default EmailCloneBusinessUnit;